import React from 'react';
import PropTypes from 'prop-types';

const Valid = ({ className, color }) => (
  <svg className={className} viewBox="550 421 13 13" focusable="false">
    <path
      stroke={color}
      strokeWidth="2.057"
      d="M552 426.888l3.16 3.112 4.84-7"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Valid.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Valid.defaultProps = {
  color: '#409FFF',
};

export default Valid;
